export default __webpack_public_path__ + "static/media/icon_buzzit.d71232be.png";